import last from 'lodash/last';
import React, { useEffect, useRef, useState, useMemo, useReducer, memo, cloneElement } from 'react';
import compact from 'lodash/compact';
import debounce from 'lodash/debounce';
import times from 'lodash/times';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function fileToBase64(_x) {
  return _fileToBase.apply(this, arguments);
}

function _fileToBase() {
  _fileToBase = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(file) {
    var reader;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reader = new FileReader();
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              reader.onerror = function () {
                reader.abort();
                reject(new DOMException('Problem parsing input file.'));
              };

              reader.onloadend = function () {
                resolve(reader.result);
              };

              reader.readAsDataURL(file);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fileToBase.apply(this, arguments);
}

function clipString(text) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 35;
  var length = text.length;
  var first = Math.max(0, Math.floor((size - 3) / 2));
  var last = Math.max(0, Math.ceil(length - first));
  return length < size ? text : "".concat(text.slice(0, first), "...").concat(text.slice(last));
}

function isIOS() {
  return navigator && /iPad|iPhone|iPod/.test(navigator.userAgent);
}

function nl2Br(content) {
  return typeof content === 'string' ? content.replace(/(?:\r\n|\r|\n)/g, '<br />') : '';
}

function sleep(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}

function isDev() {
  return process.env.NODE_ENV === 'development';
}

function getElByHash() {
  if (window && window.location.hash && window.location.hash.length > 1) {
    var id = last(window.location.hash.split('#'));
    return document.getElementById(id);
  }

  return null;
}

function scrollToEl(el) {
  var behavior = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'smooth';

  var scroll = function scroll() {
    var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return window.scrollTo({
      top: top,
      behavior: behavior
    });
  };

  if (el) {
    var top = el.offsetTop;
    scroll(top);
  } else {
    scroll(0);
  }
}

function useBodyClass(className, condition) {
  useEffect(function () {
    var classList = document.body.classList;
    var method = condition ? 'add' : 'remove';
    classList[method](className);
  }, [className, condition]);
}

function useHtmlClass(className, condition) {
  useEffect(function () {
    var classList = document.documentElement.classList;
    var method = condition ? 'add' : 'remove';
    classList[method](className);
  }, [className, condition]);
}

function useInterval(callback, delay) {
  var savedCallback = useRef(function () {}); // Remember the latest callback.

  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }

    return undefined;
  }, [delay]);
}

var useMounted = function useMounted() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMounted = _useState2[0],
      setIsMounted = _useState2[1];

  useEffect(function () {
    return setIsMounted(true);
  }, []);
  return isMounted;
};

function useOnMount(callback) {
  useEffect(function () {
    callback();
  }, []);
}

function useOnUnmount(callback) {
  useEffect(function () {
    return callback;
  }, []);
}

var usePageId = function usePageId() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;
  var home = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'home';
  var id = useMemo(function () {
    return compact(location.pathname.split('/')).join('-');
  }, [location.pathname]);
  return id || home;
};

function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}

var useProcessOnce = function useProcessOnce(fn, value) {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  useEffect(function () {
    if (!result) {
      setResult(fn(value));
    }
  }, []);
  return result || value;
};

function useQueryParam(param) {
  var params = new URLSearchParams(window.location.search);
  return params.get(param);
}

function useSetState(initialState) {
  var _useReducer = useReducer(function (oldState, newState) {
    return _objectSpread2({}, oldState, {}, newState);
  }, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      setState = _useReducer2[1];

  return [state, setState];
}

function useSafeState(initialState) {
  var _useSetState = useSetState(initialState),
      _useSetState2 = _slicedToArray(_useSetState, 2),
      state = _useSetState2[0],
      setState = _useSetState2[1];

  var mountedRef = useRef(false);
  useEffect(function () {
    mountedRef.current = true;
    return function () {
      mountedRef.current = false;
    };
  }, []);

  var safeSetState = function safeSetState(newState) {
    return mountedRef.current && setState(newState);
  };

  return [state, safeSetState];
}

var useScrollAfterLoad = function useScrollAfterLoad(doScroll) {
  useEffect(function () {
    if (doScroll) {
      var el = getElByHash() || undefined;
      scrollToEl(el);
    }
  }, [doScroll]);
};

function useToggle() {
  var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = useState(initial),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var toggler = function toggler() {
    return setValue(!value);
  };

  return [value, toggler];
}

function useWindowDimensions() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;

  var _useState = useState({
    height: 0,
    width: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1];

  useEffect(function () {
    var update = function update() {
      return setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    };

    var handleResize = debounce(update, delay);
    window.addEventListener('resize', handleResize);
    update();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [delay]);
  return dimensions;
}

var Component = function Component(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$time = _ref.time,
      time = _ref$time === void 0 ? 0 : _ref$time,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 1000 : _ref$timeout,
      _ref$onTick = _ref.onTick,
      onTick = _ref$onTick === void 0 ? function () {
    return null;
  } : _ref$onTick,
      _ref$onFinish = _ref.onFinish,
      onFinish = _ref$onFinish === void 0 ? function () {
    return null;
  } : _ref$onFinish,
      _ref$stop = _ref.stop,
      stop = _ref$stop === void 0 ? false : _ref$stop;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      elapsedTime = _useState2[0],
      setElapsedTime = _useState2[1];

  var remainingTime = time - elapsedTime / 1000;
  var isActive = active && remainingTime > 0 ? timeout : null;
  var prev = usePrevious(isActive);
  useInterval(function () {
    if (!stop) {
      onTick(Math.max(remainingTime - timeout / 1000, 0));
      setElapsedTime(elapsedTime + timeout);
    }
  }, isActive);
  useEffect(function () {
    if (prev !== null && isActive === null && elapsedTime > 0) {
      onFinish();
    }
  }, [isActive]);
  return null;
};

var Countdown = memo(Component);

var LinearGradient = function LinearGradient(_ref) {
  var children = _ref.children,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? [] : _ref$colors,
      _ref$deg = _ref.deg,
      deg = _ref$deg === void 0 ? 90 : _ref$deg;
  var division = 100 / (colors.length - 1);

  var distributeColor = function distributeColor(color, index) {
    return "".concat(color, " ").concat(index * division, "%");
  };

  var colorsString = ["".concat(deg, "deg")].concat(_toConsumableArray(colors.map(distributeColor)));

  var styles = _objectSpread2({}, children.props.style, {
    backgroundImage: "linear-gradient(".concat(colorsString.join(', '), ")")
  });

  return cloneElement(children, _objectSpread2({}, children.props, {
    style: styles
  }));
};

var boxStyles = {
  alignItems: 'stretch',
  display: 'flex',
  flexBasis: 0,
  flexGrow: 1,
  flexShrink: 1,
  minHeight: 'min-content'
};

var MasonryComponent = function MasonryComponent(_ref) {
  var children = _ref.children,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? 2 : _ref$fallback,
      _ref$adjust = _ref.adjust,
      adjust = _ref$adjust === void 0 ? 0 : _ref$adjust,
      _ref$minColumnWidth = _ref.minColumnWidth,
      minColumnWidth = _ref$minColumnWidth === void 0 ? 300 : _ref$minColumnWidth,
      props = _objectWithoutProperties(_ref, ["children", "fallback", "adjust", "minColumnWidth"]);

  var wrapper = useRef(null);
  var initialWidth = fallback * minColumnWidth;

  var _useState = useState(initialWidth),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width;

  useEffect(function () {
    if (wrapper.current) {
      var bounding = wrapper.current.getBoundingClientRect();
      setState(bounding.width);
    }
  }, [width]);
  var columns = Math.round(state / minColumnWidth);
  return React.createElement("div", _extends({
    className: "masonry-wrapper"
  }, props, {
    style: _objectSpread2({}, boxStyles, {
      maxWidth: '100%'
    }),
    ref: wrapper
  }), times(columns, function (index) {
    var isLast = index === columns - 1;
    return React.createElement("div", {
      style: _objectSpread2({}, boxStyles, {
        flexDirection: 'column',
        marginRight: isLast ? -1 : 0
      }),
      key: "tile-".concat(index)
    }, React.Children.toArray(children).filter(function (_child, filterIndex) {
      return (filterIndex + index + (columns - adjust)) % columns === 0;
    }).map(function (child, idx) {
      return cloneElement(child, _objectSpread2({}, child.props, {
        key: idx
      }));
    }));
  }));
};

var Masonry = memo(MasonryComponent);

export { Countdown, LinearGradient, Masonry, clipString, fileToBase64, getElByHash, isDev, isIOS, nl2Br, scrollToEl, sleep, useBodyClass, useHtmlClass, useInterval, useMounted, useOnMount, useOnUnmount, usePageId, usePrevious, useProcessOnce, useQueryParam, useSafeState, useScrollAfterLoad, useSetState, useToggle, useWindowDimensions };
